var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","color":"grey darken-4","dark":""}},[_c('v-spacer'),_c('div',{staticClass:"overline pa-2"},[_vm._v(" VERSION "+_vm._s(this.$appVersion)+" | "+_vm._s(this.$appAuthor)+" - "+_vm._s(this.$appCopyright)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }